import emphasis from "markdown-it/lib/rules_inline/emphasis";

function isHan(character) {
  const code = character.codePointAt(0);
  return (
    (code >= 0x3400 && code <= 0x9fff) || (code >= 0xf900 && code <= 0xfaff) || (code >= 0x20000 && code <= 0x323af)
  );
}

// Chinese prose often places punctuation inside ** and continues without spaces.
// Adjust only those double-asterisk boundaries; keep markdown-it's tokenizer and
// delimiter pairing so escaped text, code, links and unmatched markers stay safe.
export default function cjkStrong(md) {
  md.inline.ruler.before("emphasis", "cjk-strong-boundary-v1/ascii-suffix-v2", (state, silent) => {
    const start = state.pos;
    if (
      silent ||
      state.src.slice(start, start + 2) !== "**" ||
      state.src[start - 1] === "*" ||
      state.src[start + 2] === "*"
    ) {
      return false;
    }

    const before = Array.from(state.src.slice(Math.max(0, start - 2), start)).pop() || "";
    const after = Array.from(state.src.slice(start + 2, start + 4))[0] || "";
    const punctuation = (char) =>
      char !== "" && (md.utils.isPunctChar(char) || md.utils.isMdAsciiPunct(char.charCodeAt(0)));
    const canOpen = isHan(before) && punctuation(after);
    // Both 全角： and Chinese labels ending in ASCII punctuation can close
    // before CAIE/AI/2026. Keep English intraword punctuation unchanged.
    const beforePunctuation = start > 1
      ? Array.from(state.src.slice(Math.max(0, start - 4), start - 1)).pop() || ""
      : "";
    const asciiSuffix =
      /^[A-Za-z0-9]$/.test(after) &&
      (/[\u2010-\u203b\u3000-\u303f\uff00-\uffef]/u.test(before) || isHan(beforePunctuation));
    const canClose = punctuation(before) && (isHan(after) || asciiSuffix);
    if (!canOpen && !canClose) return false;

    const {scanDelims} = state;
    state.scanDelims = function scanCjkDelimiters(position, canSplitWord) {
      const result = scanDelims.call(this, position, canSplitWord);
      if (position === start && result.length === 2) {
        if (canOpen) result.can_open = true;
        if (canClose) result.can_close = true;
      }
      return result;
    };
    try {
      return emphasis.tokenize(state, silent);
    } finally {
      state.scanDelims = scanDelims;
    }
  });
}
